module.exports = __webpack_public_path__ + "img/ur.3528f605.png";